import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";
import {RoleDetailDto} from "../models/role-models";

@Injectable({
  providedIn: 'root'
})
export class RoleDetailUpdateService {

  roleDetailUpdate: Subject<RoleDetailDto | null> = new BehaviorSubject<RoleDetailDto | null>(null)

  constructor() {
  }
}
